export enum VAST_GENERATION_STATUS {
    TRANSCODING_WAITING = 'TRANSCODING_WAITING',
    TRANSCODING_COMPLETED = 'TRANSCODING_COMPLETED',
    FAILED = 'FAILED',
    ABORTED = 'ABORTED',
    SUCCEEDED = 'SUCCEEDED',
}
